export default "__VITE_ASSET__DeWqvRw1__"